import { type ReactNode, useId } from 'react';
import { Box, Stack, Tab, Tabs } from '@mui/material';

import { CredentialingComingSoon, EhrImportComingSoon } from './four-stage/IntakeStatusDashboard';

export type IntakeStatusAdminTab =
  | 'overview'
  | 'billing'
  | 'verification'
  | 'credentialing'
  | 'ehr-import';
export const INTAKE_STATUS_ADMIN_TABS = [
  'overview',
  'billing',
  'verification',
  'credentialing',
  'ehr-import',
] as const;

/** One shared staff shell; service follow-ups replace only their placeholders. */
export function IntakeStatusAdmin({
  selectedTab,
  onSelectTab,
  overview,
  billing,
  verification,
}: {
  selectedTab: IntakeStatusAdminTab;
  onSelectTab: (tab: IntakeStatusAdminTab) => void;
  overview: ReactNode;
  billing: ReactNode;
  verification: ReactNode;
}) {
  const id = useId();
  const content = {
    overview,
    billing,
    verification,
    credentialing: <CredentialingComingSoon />,
    'ehr-import': <EhrImportComingSoon />,
  };
  const labels = {
    overview: 'Overview',
    billing: 'Billing',
    verification: 'Verification',
    credentialing: 'Credentialing',
    'ehr-import': 'EHR Import',
  };
  return (
    <Stack spacing={3}>
      <Tabs
        value={selectedTab}
        onChange={(_, tab: IntakeStatusAdminTab) => onSelectTab(tab)}
        aria-label="Intake Status Admin sections"
        variant="scrollable"
        scrollButtons="auto"
      >
        {INTAKE_STATUS_ADMIN_TABS.map(tab => (
          <Tab
            key={tab}
            value={tab}
            label={labels[tab]}
            id={`${id}-${tab}-tab`}
            aria-controls={`${id}-${tab}-panel`}
          />
        ))}
      </Tabs>
      {INTAKE_STATUS_ADMIN_TABS.map(tab => (
        <Box
          key={tab}
          role="tabpanel"
          hidden={selectedTab !== tab}
          inert={selectedTab !== tab}
          id={`${id}-${tab}-panel`}
          aria-labelledby={`${id}-${tab}-tab`}
        >
          {content[tab]}
        </Box>
      ))}
    </Stack>
  );
}
